import { render, staticRenderFns } from "./sdproduct17.vue?vue&type=template&id=604968ed&scoped=true"
import script from "./sdproduct17.vue?vue&type=script&lang=js"
export * from "./sdproduct17.vue?vue&type=script&lang=js"
import style0 from "./sdproduct17.vue?vue&type=style&index=0&id=604968ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604968ed",
  null
  
)

export default component.exports